import React from 'react';
import { Check } from 'lucide-react';
import SEO from '../components/SEO';

const AdvertisePage = () => {
  return (
    <div className="min-h-screen bg-[#FAF9F7]">
      <SEO
        title="Advertise With Us"
        description="Reach Malta's most engaged couples by advertising in I DO Bridal Magazine. Explore our vendor packages and get featured in our seasonal issues."
      />
      {/* Hero Section with Image */}
      <section className="relative">
        {/* Hero Image Banner */}
        <div className="relative h-[300px] md:h-[400px] overflow-hidden">
          <img 
            src="https://images.unsplash.com/photo-1519741497674-611481863552?w=1600&h=800&fit=crop"
            alt="Advertise with I DO Magazine"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-[#FAF9F7]"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center px-4">
              <p className="text-white/90 text-xs tracking-[0.3em] uppercase mb-4">
                ADVERTISING WITH I DO
              </p>
              <h1 
                className="text-4xl md:text-6xl text-white mb-4 tracking-tight drop-shadow-lg"
                style={{ fontFamily: '"Playfair Display", serif' }}
              >
                Reach Engaged Couples
              </h1>
            </div>
          </div>
        </div>
        
        {/* Intro Text */}
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-12">
          <div className="w-20 h-0.5 mx-auto mb-8" style={{ backgroundColor: '#DE92A9' }}></div>
          <p className="text-[#757B7F] text-lg leading-relaxed max-w-3xl mx-auto">
            I DO Bridal Magazine is a premium bridal publication celebrating real weddings, bridal fashion, beauty, and the creativity of the wedding industry. Proudly part of Independent Malta, I DO offers targeted exposure to couples actively planning their wedding.
          </p>
        </div>
      </section>

      {/* Print Advertising */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 
              className="text-4xl text-[#2C2C2C] mb-4"
              style={{ fontFamily: '"Playfair Display", serif' }}
            >
              Print Advertising
            </h2>
            <p className="text-[#6B4E37]">Magazine only • Released five times a year</p>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-[#F5F3F0]">
                  <th className="text-left p-4 text-[#2C2C2C] font-semibold">Placement</th>
                  <th className="text-left p-4 text-[#2C2C2C] font-semibold">Size</th>
                  <th className="text-left p-4 text-[#2C2C2C] font-semibold">Bleed</th>
                  <th className="text-right p-4 text-[#2C2C2C] font-semibold">Rate per Issue</th>
                </tr>
              </thead>
              <tbody className="text-[#6B4E37]">
                <tr className="border-b border-[#F5F3F0]">
                  <td className="p-4">Full-page advert</td>
                  <td className="p-4">A4, 297mm (H) × 210mm (W)</td>
                  <td className="p-4">5mm bleed</td>
                  <td className="text-right p-4 font-semibold">€700</td>
                </tr>
                <tr className="border-b border-[#F5F3F0]">
                  <td className="p-4">Inside front cover</td>
                  <td className="p-4">A4, 297mm (H) × 210mm (W)</td>
                  <td className="p-4">5mm bleed</td>
                  <td className="text-right p-4 font-semibold">€825</td>
                </tr>
                <tr className="border-b border-[#F5F3F0]">
                  <td className="p-4">Inside back cover</td>
                  <td className="p-4">A4, 297mm (H) × 210mm (W)</td>
                  <td className="p-4">5mm bleed</td>
                  <td className="text-right p-4 font-semibold">€825</td>
                </tr>
                <tr className="border-b border-[#F5F3F0]">
                  <td className="p-4">Back cover</td>
                  <td className="p-4">A4, 297mm (H) × 210mm (W)</td>
                  <td className="p-4">5mm bleed</td>
                  <td className="text-right p-4 font-semibold">€950</td>
                </tr>
                <tr className="border-b border-[#F5F3F0]">
                  <td className="p-4">Double-page spread</td>
                  <td className="p-4">297mm (H) × 420mm (W)</td>
                  <td className="p-4">5mm bleed</td>
                  <td className="text-right p-4 font-semibold">€1,165</td>
                </tr>
                <tr className="border-b border-[#F5F3F0] bg-[#FDF2F4]">
                  <td className="p-4">
                    <span className="font-semibold text-[#DE92A9]">Venue for All Seasons</span>
                    <br />
                    <span className="text-sm text-[#6B4E37]">Double-page spread feature</span>
                  </td>
                  <td className="p-4">297mm (H) × 420mm (W)</td>
                  <td className="p-4">5mm bleed</td>
                  <td className="text-right p-4 font-semibold text-[#DE92A9]">€600</td>
                </tr>
                <tr className="border-b border-[#F5F3F0]">
                  <td className="p-4">Half-page (horizontal)</td>
                  <td className="p-4">140mm (H) × 195mm (W)</td>
                  <td className="p-4">No bleed</td>
                  <td className="text-right p-4 font-semibold">€375</td>
                </tr>
                <tr className="border-b border-[#F5F3F0]">
                  <td className="p-4">Half-page (vertical)</td>
                  <td className="p-4">285mm (H) × 95mm (W)</td>
                  <td className="p-4">No bleed</td>
                  <td className="text-right p-4 font-semibold">€375</td>
                </tr>
                <tr className="border-b border-[#F5F3F0]">
                  <td className="p-4">Quarter page</td>
                  <td className="p-4">140mm (H) × 95mm (W)</td>
                  <td className="p-4">No bleed</td>
                  <td className="text-right p-4 font-semibold">€190</td>
                </tr>
                <tr className="border-b border-[#F5F3F0]">
                  <td className="p-4">Strip advert (horizontal)</td>
                  <td className="p-4">50mm (H) × 195mm (W)</td>
                  <td className="p-4">No bleed</td>
                  <td className="text-right p-4 font-semibold">€190</td>
                </tr>
                <tr className="border-b border-[#F5F3F0]">
                  <td className="p-4">Strip advert (vertical)</td>
                  <td className="p-4">285mm (H) × 50mm (W)</td>
                  <td className="p-4">No bleed</td>
                  <td className="text-right p-4 font-semibold">€190</td>
                </tr>
                <tr className="border-b border-[#F5F3F0]">
                  <td className="p-4">Box spot</td>
                  <td className="p-4">60mm (H) × 60mm (W)</td>
                  <td className="p-4">No bleed</td>
                  <td className="text-right p-4 font-semibold">€60</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Artwork Specs */}
          <div className="mt-8 bg-[#F5F3F0] p-6 rounded-lg">
            <h3 className="text-xl text-[#2C2C2C] mb-4 font-semibold">Artwork Specifications</h3>
            <ul className="space-y-2 text-[#6B4E37]">
              <li><strong>File format:</strong> Print-ready PDF</li>
              <li><strong>Colour mode:</strong> CMYK</li>
              <li><strong>Resolution:</strong> 300 dpi</li>
              <li><strong>Text settings:</strong> Black text to be 100% K only</li>
            </ul>
          </div>

          <div className="mt-6 text-sm text-[#8B7D6B] space-y-1">
            <p>• Frequency discounts available for multi-issue bookings</p>
            <p>• All placements subject to availability</p>
            <p>• Prices exclude VAT, where applicable</p>
          </div>
        </div>
      </section>

      {/* Digital Advertising */}
      <section className="py-16 bg-[#FAF9F7]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 
              className="text-4xl text-[#2C2C2C] mb-4"
              style={{ fontFamily: '"Playfair Display", serif' }}
            >
              Digital Advertising
            </h2>
            <p className="text-[#6B4E37]">Online Only</p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl text-[#2C2C2C] mb-2 font-semibold">Homepage Banner</h3>
              <p className="text-2xl text-[#DE92A9] mb-4">€250/month</p>
              <p className="text-[#6B4E37] text-sm">High-visibility banner on the I DO homepage with direct click-through link. Ideal for brand awareness and traffic generation.</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl text-[#2C2C2C] mb-2 font-semibold">Category Page Banner</h3>
              <p className="text-2xl text-[#DE92A9] mb-4">€150/month</p>
              <p className="text-[#6B4E37] text-sm">Targeted exposure within relevant supplier category to couples already searching for services like yours.</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl text-[#2C2C2C] mb-2 font-semibold">Featured Vendor Listing</h3>
              <p className="text-2xl text-[#DE92A9] mb-4">€120/month</p>
              <p className="text-[#6B4E37] text-sm">Enhanced profile with images, description, contact details, and website link. Perfect for long-term visibility and SEO.</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm">
              <h3 className="text-xl text-[#2C2C2C] mb-2 font-semibold">Sponsored Article</h3>
              <p className="text-2xl text-[#DE92A9] mb-4">€300/feature</p>
              <p className="text-[#6B4E37] text-sm">Professionally written editorial showcasing your brand. Published on I DO website and remains live permanently.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Social Media */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 
              className="text-4xl text-[#2C2C2C] mb-4"
              style={{ fontFamily: '"Playfair Display", serif' }}
            >
              Social Media Advertising
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-[#F5F3F0] p-6 rounded-lg text-center">
              <h3 className="text-lg text-[#2C2C2C] mb-2 font-semibold">Instagram Feed Post</h3>
              <p className="text-3xl text-[#DE92A9] mb-4">€90</p>
              <p className="text-[#6B4E37] text-sm">One branded post with caption, tags, and hashtags</p>
            </div>

            <div className="bg-[#F5F3F0] p-6 rounded-lg text-center">
              <h3 className="text-lg text-[#2C2C2C] mb-2 font-semibold">Instagram Stories</h3>
              <p className="text-3xl text-[#DE92A9] mb-4">€70</p>
              <p className="text-[#6B4E37] text-sm">3-5 story frames with links and interactive elements</p>
            </div>

            <div className="bg-[#F5F3F0] p-6 rounded-lg text-center">
              <h3 className="text-lg text-[#2C2C2C] mb-2 font-semibold">Social Bundle</h3>
              <p className="text-3xl text-[#DE92A9] mb-4">€140</p>
              <p className="text-[#6B4E37] text-sm">Feed post + stories for stronger reach</p>
            </div>
          </div>
        </div>
      </section>

      {/* Bundle Packages */}
      <section className="py-16 bg-[#FAF9F7]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 
              className="text-4xl text-[#2C2C2C] mb-4"
              style={{ fontFamily: '"Playfair Display", serif' }}
            >
              Bundle Packages
            </h2>
            <p className="text-[#6B4E37]">Print + Digital</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Silver */}
            <div className="bg-white p-8 rounded-lg shadow-md">
              <h3 className="text-2xl text-[#2C2C2C] mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>Silver Package</h3>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start gap-2 text-[#6B4E37]">
                  <Check className="text-[#DE92A9] flex-shrink-0 mt-1" size={18} />
                  <span>Half Page Print Ad</span>
                </li>
                <li className="flex items-start gap-2 text-[#6B4E37]">
                  <Check className="text-[#DE92A9] flex-shrink-0 mt-1" size={18} />
                  <span>Featured Vendor Listing (1 Month)</span>
                </li>
                <li className="flex items-start gap-2 text-[#6B4E37]">
                  <Check className="text-[#DE92A9] flex-shrink-0 mt-1" size={18} />
                  <span>1 Instagram Feed Post</span>
                </li>
              </ul>
              <a href="/contact" className="block text-center bg-[#DE92A9] hover:bg-[#C9758F] text-white py-3 rounded transition-colors">
                Contact for Pricing
              </a>
            </div>

            {/* Gold */}
            <div className="bg-white p-8 rounded-lg shadow-lg border-2 border-[#DE92A9] relative">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#DE92A9] text-white px-4 py-1 text-xs tracking-wider rounded-full">
                POPULAR
              </div>
              <h3 className="text-2xl text-[#2C2C2C] mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>Gold Package</h3>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start gap-2 text-[#6B4E37]">
                  <Check className="text-[#DE92A9] flex-shrink-0 mt-1" size={18} />
                  <span>Full Page Print Ad</span>
                </li>
                <li className="flex items-start gap-2 text-[#6B4E37]">
                  <Check className="text-[#DE92A9] flex-shrink-0 mt-1" size={18} />
                  <span>Featured Vendor Listing (3 Months)</span>
                </li>
                <li className="flex items-start gap-2 text-[#6B4E37]">
                  <Check className="text-[#DE92A9] flex-shrink-0 mt-1" size={18} />
                  <span>Sponsored Website Feature</span>
                </li>
                <li className="flex items-start gap-2 text-[#6B4E37]">
                  <Check className="text-[#DE92A9] flex-shrink-0 mt-1" size={18} />
                  <span>2 Instagram Posts + Stories</span>
                </li>
              </ul>
              <a href="/contact" className="block text-center bg-[#DE92A9] hover:bg-[#C9758F] text-white py-3 rounded transition-colors">
                Contact for Pricing
              </a>
            </div>

            {/* Platinum */}
            <div className="bg-white p-8 rounded-lg shadow-md">
              <h3 className="text-2xl text-[#2C2C2C] mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>Platinum Package</h3>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start gap-2 text-[#6B4E37]">
                  <Check className="text-[#DE92A9] flex-shrink-0 mt-1" size={18} />
                  <span>Double Page Print Spread</span>
                </li>
                <li className="flex items-start gap-2 text-[#6B4E37]">
                  <Check className="text-[#DE92A9] flex-shrink-0 mt-1" size={18} />
                  <span>Homepage Banner (1 Month)</span>
                </li>
                <li className="flex items-start gap-2 text-[#6B4E37]">
                  <Check className="text-[#DE92A9] flex-shrink-0 mt-1" size={18} />
                  <span>Featured Vendor Listing (6 Months)</span>
                </li>
                <li className="flex items-start gap-2 text-[#6B4E37]">
                  <Check className="text-[#DE92A9] flex-shrink-0 mt-1" size={18} />
                  <span>Sponsored Editorial Feature</span>
                </li>
                <li className="flex items-start gap-2 text-[#6B4E37]">
                  <Check className="text-[#DE92A9] flex-shrink-0 mt-1" size={18} />
                  <span>Social Media Promotion</span>
                </li>
              </ul>
              <a href="/contact" className="block text-center bg-[#DE92A9] hover:bg-[#C9758F] text-white py-3 rounded transition-colors">
                Contact for Pricing
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AdvertisePage;